import {
  STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_BEGIN,
  STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_FAILURE,
  STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_SUCCESS
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_BEGIN:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
        }
      }
    case STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_SUCCESS:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          dataStateMachine: action.data
        }
      }
    case STOCK_TAKING_CAR_MANAGMENT_STATE_MACHINE_FAILURE:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
        }
      }
    default:
      return state
  }
}
